<dx-popup
  width="70%"
  [height]="500"
  [showTitle]="true"
  class="sensor-history-popup"
  [title]="title"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [elementAttr]="{ class: 'sensor-history-popup' }"
  (onHidden)="closed($event)"
  (onShowing)="onShowing($event)"
  (onShown)="onShown($event)"
  [(visible)]="visible">

  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
            text: 'Fermer',
            onClick: close
        }">
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <app-sensor-history *ngIf="sensor" [sensor]="sensor" [request]="request">
      <ng-template let-sensor let-request="request" let-toolbar=toolbar>
        <ng-template
          *ngTemplateOutlet="templateRef; context : {$implicit: sensor, request: request, toolbar: toolbar}"></ng-template>
      </ng-template>
    </app-sensor-history>

    <dx-load-panel
      class="mb-loading"
      shadingColor="rgba(0,0,0,0.2)"
      [visible]="!loader.isLoaded"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [closeOnOutsideClick]="false">
      <div *dxTemplate="let data of 'content'">{{loader.loadedStr()}}</div>
    </dx-load-panel>
  </div>
</dx-popup>
